import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { ClerkProvider } from '@clerk/clerk-react';
// Typefaces served from our own domain, not Google Fonts: a widget on
// someone else's site should not send its visitors' IPs to a third party.
// The same weights the Google Fonts link loaded until 2026-10-02.
import '@fontsource/dm-sans/300.css';
import '@fontsource/dm-sans/400.css';
import '@fontsource/dm-sans/400-italic.css';
import '@fontsource/dm-sans/500.css';
import '@fontsource/dm-sans/600.css';
import '@fontsource/dm-sans/700.css';
import '@fontsource/fraunces/300.css';
import '@fontsource/fraunces/400.css';
import '@fontsource/fraunces/400-italic.css';
import '@fontsource/fraunces/500.css';
import '@fontsource/fraunces/600.css';
import '@fontsource/fraunces/700.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { captureUTM } from './utils/utm';
import { isWidgetRoute } from './utils/isWidgetRoute';
// import * as serviceWorkerRegistration from './serviceWorkerRegistration'; // Import serviceWorkerRegistration

// Capture UTM params on first load
captureUTM();

// Render static builds don't reliably expose REACT_APP_ env vars, so we fall
// back to the hardcoded publishable key (public client id, safe in bundle).
const clerkPubKey =
  process.env.REACT_APP_CLERK_PUBLISHABLE_KEY ||
  'pk_live_Y2xlcmsua2FyYm9ua2l0LmNvbSQ';

// Widget embeds get NO ClerkProvider. Clerk reads localStorage on init, which
// a cross-site iframe denies, and the resulting SecurityError left every embed
// stuck on "Connecting..." forever. Widgets never need auth -- see
// utils/isWidgetRoute.js for the full story.
const embedded = isWidgetRoute();

const tree = (
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {embedded ? tree : (
      <ClerkProvider publishableKey={clerkPubKey}>{tree}</ClerkProvider>
    )}
  </React.StrictMode>
);

// Actively unregister any existing service worker
// serviceWorkerRegistration.unregister(); // Add this line

// Send Core Web Vitals to GA4 (no-ops gracefully if GA is not configured)
reportWebVitals();